import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { FunctionCallService } from './function-calls.service';
import { GoogleAnalyticsService } from './google-analytics.service';

/// <reference types="google.analytics" />
// import {} from '@types/google.analytics'; 
declare let ga: any;

import * as Bowser from 'bowser'; // TypeScript

@Injectable()
export class PwaService
{
    // These are interchangable
    promptEvent: any;
    deferredPrompt: any;
    
    public browserObj;

    showIOSOnlyInstallButton = false;

    // Store NETWORK Status
    offline: boolean;

    constructor(private swUpdate: SwUpdate,
                public googleAnalyticsService: GoogleAnalyticsService,
                private functionCallService: FunctionCallService)
    {
        // console.log('Pwa Service Constructor');

        // this.getBrowserInfo();
        // this.checkDeviceInfo();  
              

        console.log('Automatcially Check for Update - pwa service : ', this.swUpdate.isEnabled);
        if (this.swUpdate.isEnabled)
        {

            this.swUpdate.available.subscribe((event) => 
            {
                // Getting notified of available updates. These are new versions of the app to be loaded if the page is refreshed.
                console.log('current version is', event.current);
                console.log('available version is', event.available);            
                
                console.log('Prompt user to update');                

                if(confirm('New version available. Load New Version?')) {

                    window.location.reload();
                }

            });

        }

        swUpdate.activated.subscribe((event) => 
        {
            // Getting notified of update activation. This is when the service worker starts serving a new version of the app immediately.
            console.log('old version was', event.previous);
            console.log('new version is', event.current);
        }); 


        // Original Function
        // swUpdate.available.subscribe((event) =>
        // {
        //     console.log('current version is', event.current);
        //     console.log('available version is', event.available);            
        //     console.log('Prompt user to update');

        //     if(this.askUserToUpdate(event))
        //     {
        //         window.location.reload();
        //     }

        //     // Forcing update activation
        //     // if(this.askUserToUpdate(event)) 
        //     // {
        //     //     swUpdate.activateUpdate().then(() => document.location.reload());
        //     // }            

        // });

       
    }


    askUserToUpdate(event)
    {
        console.log('askUserToUpdate', event);
        return confirm('Want to update?');
    }


    // Manually Check for Updates
    checkForUpdate() 
    {
        // TODO: Show spinner for loading

        console.log('PWA Service - check for update', this.swUpdate.isEnabled);
        if (this.swUpdate.isEnabled) 
        {
            console.log('Checking for updates...');
            this.swUpdate.checkForUpdate().then(() => 
            {
                this.updateToLatest();

            }).catch((err) => 
            {
                console.error('Error when checking for update', err);
            });
        }
    }    


    updateToLatest(): void 
    {
        console.log('Updating to latest version.');
        this.swUpdate.activateUpdate().then(() => 
        {   
            document.location.reload();

            alert('Scoreboard Updated');
        });
    }    


    checkDeviceInfo()
    {

        console.log('checking device info ---- ');

        // Get the Device Browser Info
        this.getBrowserInfo();

        // ----------------------------------------------
        // Check for Device / Browser Type / Display Mode
        // http://lancedikson.github.io/bowser/docs/index.html#use-cases
        // ----------------------------------------------
        // Android
        if(this.browserObj.os == 'Android')
        {
            if(this.browserObj.name == 'Chrome' || this.browserObj.name == 'Firefox' || this.browserObj.name == 'Samsung Internet for Android')
            {
                this.getPWAInstallPrompt();
            }
            else if(this.browserObj.name == 'Amazon Silk') // Amazon HD Tablets
            {
                // alert('Amazon Tablets');
                this.getPWAInstallPrompt();
            }            
        }
        else if(this.browserObj.os == 'iOS') // IOS
        {
            if(this.browserObj.name == 'Safari' || this.browserObj.name == 'Chrome' || this.browserObj.name == 'Firefox')
            {
                // Show Install to Home Screen Button for IOS / Safari Only
                this.showIOSOnlyInstallButton = true; 
                this.functionCallService.addToHomeScreenIOSService(true);
                // iOS analytics
                // Send event to Google Analytics It was installed
                this.googleAnalyticsService.sendGoogleEvent('scoreBoardPwa', 'macOSDevice', `deviceType`, 1);  
            }    
        }
        else if(this.browserObj.os == 'macOS')    // Mac OS
        {
            if(this.browserObj.name == 'Safari')
            {
                // Show Install to Home Screen Button for IOS / Safari Only
                this.showIOSOnlyInstallButton = true; 
                this.functionCallService.addToHomeScreenIOSService(true);
                // iOS analytics
                // Send event to Google Analytics It was installed
                this.googleAnalyticsService.sendGoogleEvent('scoreBoardPwa', 'macOSDevice', `deviceType`, 1);  
            }
            else if(this.browserObj.name == 'Chrome')
            {
                this.getPWAInstallPrompt();
            }
            else if(this.browserObj.name == 'Firefox')
            {
                this.getPWAInstallPrompt();
                // alert('PWAs currently not support for FireFox on MacOS');
            }      
        }
        else if(this.browserObj.os == 'Windows')  // Windows
        {
            if(this.browserObj.name == 'Chrome')
            {
                this.getPWAInstallPrompt();
            }
            else if(this.browserObj.name == 'Firefox')
            {
                this.getPWAInstallPrompt();
            }      
        }
        else if(this.browserObj.os == 'Linux')  // Linux
        {
            if(this.browserObj.name == 'Chrome')
            {
                this.getPWAInstallPrompt();
            }
            else if(this.browserObj.name == 'Firefox')
            {
                this.getPWAInstallPrompt();
            }      
            else if(this.browserObj.name == 'Opera')
            {
                this.getPWAInstallPrompt();
            }     
            
        }    
    }


    getBrowserInfo()
    {
        const browserInfo: any = Bowser.getParser(window.navigator.userAgent);
        // console.log(`The current browser name is " ${browserInfo.getBrowserName()}"`);
        // console.log(`The current browser name is "`, browserInfo);
        console.log(Bowser.parse(window.navigator.userAgent));

        this.browserObj = {
            name: browserInfo.parsedResult.browser.name,
            version: browserInfo.parsedResult.browser.version,
            os: browserInfo.parsedResult.os.name,
            platform: browserInfo.parsedResult.platform.type,
            vendor: browserInfo.parsedResult.platform.vendor,
            model: browserInfo.parsedResult.platform.model
        };

    }


    // ----------------------------------------------
    // Get the PWA install Prompt
    // ----------------------------------------------
    getPWAInstallPrompt()
    {
        console.log('getPWAInstallPrompt ---- ');
        // We are in the browser
        window.addEventListener('beforeinstallprompt', (event) =>
        {
            console.log('beforeinstallprompt triggered - ');

            // Prevent the mini-infobar from appearing on mobile
            event.preventDefault();  

            // Stash the event so it can be triggered later.
            this.deferredPrompt = event;   

            this.functionCallService.storedDefferedPrompt(this.deferredPrompt);       

            // Update UI notify the user they can install the PWA
            // Use custom diglog prompt
            // This will Automatically show the Custom Install Prompt to the user
            // console.log('Install Prompt Opened automatically --');
            // Do NOT open the prompt automatically - 10-19-2020
            // this.openInstallPromptDialog();
            // window.removeEventListener('beforeinstallprompt', window);

            return false;
        });    
    }      



    // ----------------------------------------------
    // Show the PWA Install Prompt
    // ----------------------------------------------
    showPWAInstallPromotion()
    {
        console.log('deferred prompt : ', this.deferredPrompt);

        if(this.deferredPrompt != undefined && this.deferredPrompt != null)
        {


            // Show the install prompt
            this.deferredPrompt.prompt();

            // Wait for the user to respond to the prompt
            this.deferredPrompt.userChoice.then((choiceResult) => 
            {
            if (choiceResult.outcome === 'accepted') 
            {
                console.log('User accepted the install prompt');

                

                // console.log('Send Data to Server - PWA Installed');    
                // Send event to Google Analytics It was installed
                this.googleAnalyticsService.sendGoogleEvent('scoreBoardPwa', 'pwaInstalled', `userChoice`, 1);         
                    
            } 
            else 
            {
                console.log('User dismissed the install prompt');

                // console.log('Send Data to Server - PWA NOT Installed');
                // Send event to Google Analytics It was NOT installed
                this.googleAnalyticsService.sendGoogleEvent('scoreBoardPwa', 'pwaNotInstalled', `userChoice`, 1);  

            }

            this.deferredPrompt = null;     

            }); 
        }
        else
        {
            alert('There was an issue installing ACL Scoreboard PWA');
        }

    }    

}
